export default __webpack_public_path__ + "static/media/avocado.e475048b.png";